var _circle, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmountBagSubIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#128A08"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.75,
    width: 9.12162,
    height: 12.5,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1188_43802",
    transform: "matrix(0.0185185 0 0 0.0135135 -0.425926 -0.162162)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1188_43802",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACjElEQVR4nO3cu27TYBiAYUssqDOsUEHLqTDBNXAYoMcL6TWAuB4OE7AxwQUwUw6tYEOoQ2mXFxn+iAoS57fjxh/2+0hZKvvLX79xEittikKSJEmSJEmSpBCAy+Wt63Wo+BVjCdgFvgJXPCgdAs4BO/zxGbhglG5iLAIf+Ff5s0WjzP/MeM9kHz1T4sQ4HuXivNY1SMD5zBgjn4wSJ8aIUQLFGDFKyzF2mJ1RAsU4HmWplUfKQK8zdmhfefFolCAxRoxSI8ZyOmAn7QtwtcHJO7gYu3OIYZSWYxy0tA3pPpfn8ojraYxD4H7GdrdrRCmfvq51fRz+2xjF7/0qpW3u1IhSfp4y7CjApSYxcoOk7YxSI8ZejRgP/to/K0ja9q5nygnGqBskbW+UlmKsTphTK0ja5x7wo8ZrykoxgL8OmTlG0yBpP6OkA3G2xhX4YVWMWYKkfVfTfeQo13ym6BvgYeYBOALWMuY1DpL2X0v3leNx0TfAy8wY65nzZgqSZqxnRnld9A3wNCPGRo15MwdJczYyorwq+gbYnhJjs+a8VoKkWZtTomwXfQOcBt6O+WXLF9etBvMqNZi3NeGF/k259qKPgAXgEfAuvf19AtxsOKtSw5m30lPrXlpj+UZkocmswWGKrtc3OBgkFgwSCwaJBYPEgkFiwSCxYJBYMEgsGCQWDBILBokFg8SCQWLBILFgkFgwSCwYJBYMEgsGiQWDxIJBYsEgsWCQWDBILBgkFgwSCwaJBYPEgkFiwSCxYJBYMEgsGCQWDBILBokF+F7R5FvX6xsc4HlFkGddr29wgBVgf0yM/d5/rVJUwI30HSpH6Z/+XwDXu17X4AGnytvgD4QkSZIkSZIkSSrG+AmxVZ4yYAx9FwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountBagSubIcon);
export default __webpack_public_path__ + "static/media/AmountBagSubIcon.507d1ad90b664ecef2ebd3e34370aa65.svg";
export { ForwardRef as ReactComponent };